<template>
  <div>
      <div class="goUPDown goMessage">
          <div v-if="scrollTop>0 && !globalRfType">
              <img src="@/assets/goUP.svg" class="goUP" @click="scrollVal('top')">
              <img src="@/assets/goDown.svg" class="goDown" @click="scrollVal('bottom')">
          </div>
          <div class="msBox">
              <p class="insideMsBox" @click="lookMessage">
               <i class="red-icon" v-if="noReadNum"></i>
               <img src="@/assets/message.svg" class="message-icon">
              </p>
          </div>
      </div>
      <!-- 消息提示 -->
      <message-notice ref="messageNotice"></message-notice>
  </div>
  
</template>

<script>
import {messageNoRead} from '@/components/api/messageApi.js'
import MessageNotice from '@/components/messageNotice'
export default {
      components:{
            MessageNotice
      },
      props:{
            globalRfType:{
                   type: Boolean,
                   default: true
            }
      },
      data(){
            return{
                  scrollTop:0,
                  noReadNum:0
            }
      },
      beforeDestroy() {
       this.listenerFunction()
      },
      mounted(){
            this.listenerFunction()
            this.getMessageNoRead()
      },
      methods:{
            listenerFunction(e){
                  document.addEventListener('scroll',this.handleScroll,true)
            },
            handleScroll (event) {
                  this.scrollTop=event.target.scrollTop 
            },
            scrollVal(val){
                  this.$emit('scrollToView',val)
            },
            // 查看消息通知
            lookMessage(){
                  this.$refs.messageNotice.openDrawerMsg()
            },
            getMessageNoRead(){
                  try{
                        messageNoRead().then(res =>{
                              if(res.code == 200){
                                    this.noReadNum = res.data
                              }
                        })
                  }catch(error){

                  }
            }

      }
}
</script>
<style lang="scss" scoped>
  .goUPDown{
      position: fixed;
      right: 0px;
      bottom: 70px;
      z-index: 10;
      img{
      cursor: pointer;
      display: block;
      margin: auto;
      }
}
.goMessage{
  .msBox{
     width: 52px;
    height: 52px;
    position: relative;
    margin-top:6px;
    .insideMsBox{
        width: 32px;
       height: 32px;
       background: #333333;
        box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.11);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;
        border-radius: 50%;
        .message-icon{
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
        }
    }
    .red-icon{
          position: absolute;
            width: 10px;
            height: 10px;
            display: block;
            background: #FF5000;
            right: 0px;
            top: -4px;
            border-radius: 50%;
            z-index: 0;
    }
    
  }
}
</style>